/**
 * Цифры рядом с пунктами меню — «Обучение» и «Жалобы».
 *
 * Панель и экран живут в разных ветках дерева и общей памяти не имеют.
 * Поэтому цифру считала панель — один раз, при заходе, — и она врала: человек
 * разбирал жалобы, а панель показывала, сколько их было на входе.
 *
 * Прятать цифру на самом экране оказалось не лучше: она пропадала без
 * причины, будто сломалась. Правильнее наоборот — пусть экран, который знает
 * точное число, говорит его панели. Панель считает сама только при заходе и
 * при переходах, а дальше слушает.
 *
 * Модуль без React и без сети: одна шина на приложение.
 */

export type BadgeKind = "learning" | "complaints";

type Listener = (kind: BadgeKind, value: number) => void;

const listeners = new Set<Listener>();

/** Экран сообщает панели, сколько осталось. */
export function publishBadge(kind: BadgeKind, value: number): void {
  for (const fn of listeners) fn(kind, value);
}

/** Панель слушает; возвращается отписка. */
export function onBadge(fn: Listener): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}
